import { autoCompleteLocationIq } from '../../map/locationiq_autocomplete';
import { MapForm } from './map_form';

export class AddressForm extends MapForm {
  searchableCountryCodes;

  constructor(locationIqPublicMapApiKey, markerImgUrl, latitude, longitude, searchableCountryCodes) {
    super(locationIqPublicMapApiKey, markerImgUrl, latitude, longitude);
    this.searchableCountryCodes = searchableCountryCodes;
  }

  init() {
    // we need a timeout to wait for the libraries to load in the dom
    setTimeout(() => {
      this.initMap();
      this.createDraggableMarker();
      this.autoCompleteLocation();
      this.markerMovedCallback();
    }, 1000);
  }

  autoCompleteLocation() {
    autoCompleteLocationIq({
      selector: '#address-full-input',
      apiKey: this.locationIqPublicMapApiKey,
      on_select_callback: (selection) => {
        this.geoLocationValues = selection;
        this.longitude = selection.lon;
        this.latitude = selection.lat;
        this.fillGeoLocationValues();
        this.createDraggableMarker();
      },
      countryCode: this.searchableCountryCodes,
    }).then(() => {
      autoCompleteLocationIq({
        selector: '#geo-address-city-input',
        placeHolder: '',
        apiKey: this.locationIqPublicMapApiKey,
        search: 'city',
        countryCode: this.searchableCountryCodes,
        on_select_callback: (selection, input) => {
          this.geoLocationValues = selection;
          this.longitude = selection.lon;
          this.latitude = selection.lat;

          this.fillGeoLocationValues();
          this.createDraggableMarker();
          input.value = selection.result.city;
          this.map.setZoom(14);
        },
      });
    });
  }
}
